import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import BackgroundImage from '@/operator/components/general/BackgroundImage';
import { StyledTwoScreensWrapper } from '@/operator/components/modules/AuthPage/Styles';
import { MessageWithTip } from '@/operator/components/modules/AuthPage/setup/MessageWithTip';
import { StyledWidthWrapper } from '@/operator/components/modules/AuthPage/setup/Styles';
import { StyledDraggableContainer } from '@/operator/components/modules/AuthPage/setup/progress/Styles';
import ProgressPage from '@/operator/components/progress';
import { CircularProgress } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import image from '@/operator/public/assets/images/background/team-building.svg';

import { useAppContext } from '../../../context/AppContext';

const tenantURLDomain = process.env.NEXT_PUBLIC_TENANT_URL_DOMAIN;

const ProgressPageWrapper = (): JSX.Element => {
    const { operatorFrontendEndpointsMigration } = useFlags();
    const { vanityURL } = useAppContext();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { t } = useTranslation();

    if (operatorFrontendEndpointsMigration === undefined) {
        return (
            <StyledTwoScreensWrapper>
                <MessageWithTip
                    Icon={CircularProgress}
                    headline={t('Auth.Setup.Progress.Content.Header')}
                    description={t('Auth.Setup.Progress.Content.Subheader')}
                    tip={t('Auth.Setup.Progress.Content.Tip.Message') as string}
                    tipHeadline={
                        t('Auth.Setup.Progress.Content.Tip.Headline') as string
                    }
                    footerSlot={
                        <StyledWidthWrapper
                            style={{
                                marginTop: '14px',
                                marginLeft: '4px',
                            }}
                        >
                            <Link
                                to={`https://${vanityURL}.${tenantURLDomain}`}
                                style={{
                                    textDecoration: 'none',
                                    color: 'black',
                                }}
                            >
                                <StyledDraggableContainer>
                                    <Typography
                                        variant="bodyExtraSmall"
                                        style={{ marginBottom: 0 }}
                                    >
                                        {t(
                                            'Auth.Setup.Progress.Content.BookMark.SubHeader',
                                        )}
                                    </Typography>
                                </StyledDraggableContainer>
                            </Link>
                        </StyledWidthWrapper>
                    }
                />
                <BackgroundImage src={image} />
            </StyledTwoScreensWrapper>
        );
    }

    return (
        <ProgressPage
        //Uncoment untilt tenant provision is ready for the sdk
        // operatorFrontendEndpointsMigration={
        //     operatorFrontendEndpointsMigration as boolean
        // }
        />
    );
};

// export async function getStaticProps(context: GetStaticPathsContext) {
//     // extract the locale identifier from the URL in the future
//     // at this point default one will serve is
//     const { defaultLocale } = context;

//     return {
//         props: {
//             // pass the translation props to the component
//             ...(await serverSideTranslations(defaultLocale as string)),
//         },
//     };
// }

export default ProgressPageWrapper;
